<main role="main" class="container generic-error">
  <section class="">
    <div class="row error-content">
      <div class="col-12">
        <img class="center-block" src="assets/img/ko.png" alt="Algo ha salido mal" />
      </div>

      <div class="col-12">
        <p class="text-center">
          {{ 'error_page_err_generic' | translate }}
        </p>
      </div>

      @if (!isComponent) {
        <div class="col-12">
          <a href="javascript:;" [routerLink]="LAYOUT_NAME" class="btn btn-02">{{
            'error_page_btn_home' | translate
          }}</a>
        </div>
      }
    </div>
  </section>
</main>
